/**
 * @ngdoc directive
 * @name kareo.ui.shared.assets:keyeventListNavigation
 * @element div
 * @function
 * @description
 * Allows list navigation using upArrow, downArrow and list selection by enter.
 *
 * @param {string} selectedLiClass Assign class which highlights li
 * @param {string} scrollableLiClass Assign each li with some common class ex: scroll-items using
   this directive can get list of scrollable li's
 * @param {string} parentTagClass Assign li's parent tag class
 * @example
 <example module="kareo.ui.shared.directives.keyevent-list-navigation">
 <file name="index.html" >
 <div keyevent-list-navigation="keyevent-list-navigation"
      selected-li-class="selected" scrollable-li-class="scroll-items" parent-tag-class="list-scroll-parent"
      call-back="callBack(index)">
     <input type='text'/>
     <div>
         <ul class="lined-link-list">
             <div class="patient-list list-scroll-parent">
                 <li><a class="scroll-items">list1</a></li>
                 <li><a class="scroll-items">list2</a></li>
                 <li><a class="scroll-items">list3</a></li>
                 <li><a class="scroll-items">list4</a></li>
             </div>
         </ul>
     </div>
 </div>
 </file>
 </example>
 */
(function () {
  angular.module('kareo.ui.shared.directives.keyevent-list-navigation', [])
  .directive('keyeventListNavigation', keyeventListNavigationDirective);
  keyeventListNavigationDirective.$inject = ['$parse'];
  function keyeventListNavigationDirective($parse) {
    return {
      restrict: 'AC',
      link: function keyeventListNavigationLink(scope, element, attrs) {
        var KEYBOARD__EVENT_DOWN_ARROW = 40;
        var KEYBOARD__EVENT_UP_ARROW = 38;
        var KEYBOARD__EVENT_ENTER = 13;
        var selectedLiClass = attrs.selectedLiClass;
        var listParentTagClass = attrs.parentTagClass;
        var scrollableLiClass = attrs.scrollableLiClass;
        var callBack = $parse(attrs.callBack);
        var selectedItem = -1;
        element.bind('keydown', handleListScroll);
        // Set list scroll top.
        var setScrollOffset = function (listEle, parentContainer, isPrevious) {
          if (!isPrevious) { // for down arrow
            parentContainer.scrollTop = listEle.offsetTop - parentContainer.offsetHeight;
          } else {
            parentContainer.scrollTop = (listEle.offsetTop < listEle.offsetHeight) ? 0 : listEle.offsetTop;
          }
        };
        var adjustScroll = function (selectedLi, isPrevious) {
          var tempElement;
          if (selectedLi) {
            if (selectedLi.parentElement.classList.contains(listParentTagClass)) {
              tempElement = selectedLi;
            } else {
              tempElement = selectedLi.parentElement;
            }
            var child = isPrevious ? tempElement.previousElementSibling :
                tempElement.nextElementSibling;
            var parent = element[0].getElementsByClassName(listParentTagClass)[0];
            if (!child) {
              parent.scrollTop = isPrevious ? 0 : tempElement.offsetTop;
              return;
            }
            setScrollOffset(child, parent, isPrevious);
          }
        };

        function keyDownHandler(scrollElementList) {
          if (scrollElementList.length) {
            var max = scrollElementList.length - 1;
            if (selectedItem >= max) {
              selectedItem = max;
            } else {
              selectedItem += 1;
            }
          }
          angular.element(scrollElementList[selectedItem - 1]).removeClass(selectedLiClass);
          angular.element(scrollElementList[selectedItem]).addClass(selectedLiClass);
          adjustScroll(scrollElementList[selectedItem], false);
        }

        function keyUpHandler(scrollElementList) {
          if (scrollElementList.length) {
            if (selectedItem > 0) {
              selectedItem -= 1;
            } else {
              selectedItem = 0;
            }
            angular.element(scrollElementList[selectedItem + 1]).removeClass(selectedLiClass);
            angular.element(scrollElementList[selectedItem]).addClass(selectedLiClass);
            adjustScroll(scrollElementList[selectedItem], true);
          }
        }
        function handleListScroll(event) {
          var keyCode = event.keyCode;
          var scrollElementList = element[0].getElementsByClassName(scrollableLiClass);
          if (!(keyCode === KEYBOARD__EVENT_DOWN_ARROW || keyCode === KEYBOARD__EVENT_UP_ARROW || keyCode === KEYBOARD__EVENT_ENTER)) {
            selectedItem = -1;
            return;
          }

          if (scrollElementList[0] && scrollElementList[0].classList.contains(selectedLiClass)) {
            selectedItem = 0;
          }

          if (keyCode === KEYBOARD__EVENT_DOWN_ARROW) {
            keyDownHandler(scrollElementList);
          }
          if (keyCode === KEYBOARD__EVENT_UP_ARROW) {
            keyUpHandler(scrollElementList);
          }
          if (keyCode === KEYBOARD__EVENT_ENTER) {
            callBack(scope, { index: selectedItem });
          }
        }
      }
    };
  }
})();
